import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getEventAccessLogs,
  getAttendeeAccessPass,
  patchAttendeeAccessPass
} from "../../../../Redux/Reducers/communityReducer";
import { SlLocationPin } from "react-icons/sl";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { IoCloudOfflineOutline } from "react-icons/io5";
import { PiClockClockwise } from "react-icons/pi";
import { MdOutlineQrCodeScanner } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { HiOutlineCheckCircle, HiOutlineXCircle } from "react-icons/hi";
import jsQR from "jsqr";

const DEFAULT_IMAGE = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJUt3PE61yxQt2pJlLy5FJUP6ui46BBHmnFotsysgdKKY9pQsMc9oRkoqk2Sr--qdpbuk&usqp=CAU";
const DEFAULT_AVATAR = "https://www.shutterstock.com/image-vector/vector-flat-illustration-grayscale-avatar-600nw-2281862025.jpg";

// ── User Details Modal ───────────────────────────────────────────────────────
const UserDetailsModal = ({ user, onClose, singleEvent }) => {
  if (!user) return null;
console.log("userDATATATAAT", user, singleEvent)
  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  };

  const formatDuration = (minutes) => {
    if (!minutes) return "N/A";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours === 0) return `${mins} mins`;
    if (mins === 0) return `${hours} hr${hours !== 1 ? "s" : ""}`;
    return `${hours} hr${hours !== 1 ? "s" : ""} ${mins} min${mins !== 1 ? "s" : ""}`;
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalBox}>
        {/* Header */}
        <div style={styles.modalHeader}>
          <span style={styles.modalTitle}>Attendee Details</span>
          <button style={styles.closeBtn} onClick={onClose}>
            <IoClose size={22} />
          </button>
        </div>

        {/* User Details Card */}
        <div style={styles.ticketCardWrapper}>
          <div style={styles.ticketCard}>
            {/* Header with Gradient */}
            <div style={styles.ticketHeader}>
              <div>
                <span style={styles.eventTicketLabel}>ATTENDEE INFORMATION</span>
                <span style={styles.eventType}>
                  {singleEvent?.event_access_level || ""} Event
                </span>
              </div>
              <div style={styles.dotsContainer}>
                <span style={styles.dot}></span>
                <span style={styles.dot}></span>
                <span style={styles.dot}></span>
              </div>
            </div>

            {/* Banner Image */}
            <div style={styles.bannerImage}>
              <img
                src={singleEvent?.feature_image || DEFAULT_IMAGE}
                alt="Event"
                style={styles.bannerImg}
                onError={(e) => {
                  e.target.src = DEFAULT_IMAGE;
                }}
              />
              <div style={styles.bannerOverlay} />
            </div>

            {/* Centered Avatar overlapping banner */}
            <div style={styles.avatarContainer}>
              <img
                src={user.attendee?.profile_url || DEFAULT_AVATAR}
                alt={user.attendee?.name}
                style={styles.avatar}
                onError={(e) => {
                  e.target.src = DEFAULT_AVATAR;
                }}
              />
            </div>

            {/* Attendee Info */}
            <div style={styles.attendeeInfo}>
              <h4 style={styles.attendeeName}>{user.attendee?.name || "N/A"}</h4>
              <div style={styles.contactRow}>
                <span style={styles.contactIcon}>📧</span>
                <span style={styles.contactText}>{user.attendee?.email || "N/A"}</span>
              </div>
              <div style={styles.contactRow}>
                <span style={styles.contactIcon}>📞</span>
                <span style={styles.contactText}>{user.attendee?.phone || "N/A"}</span>
              </div>
            </div>

            {/* Event Title & Status Chip */}
            <div style={styles.eventTitleRow}>
              <h3 style={styles.eventTitle}>{user.event?.title || "Event Name"}</h3>
              <span style={{
                ...styles.statusChip,
                background: user.action === "APPROVED" ? "#1A9E5A" : 
                           user.action === "REJECTED" ? "#E03B3B" : "#3B5998",
              }}>
                {user.action || user.attendance_status || "PENDING"}
              </span>
            </div>

            {/* Event Info Details */}
            <div style={styles.eventDetails}>
              {/* Performed By */}
              <div style={styles.detailRow}>
                <span style={styles.detailIcon}>👤</span>
                <span style={styles.detailText}>
                  <strong>Verified by:</strong> {user.performed_by?.name || user.created_by?.split("<")[0]?.trim() || "N/A"}
                </span>
              </div>

              {/* Timestamp */}
              <div style={styles.detailRow}>
                <span style={styles.detailIcon}>⏰</span>
                <span style={styles.detailText}>
                  <strong>Verified at:</strong> {formatDate(user.created_at)}
                </span>
              </div>

              {/* Location/Meeting Link */}
              <div style={styles.detailRow}>
                {user.event?.mode === "Offline" ? (
                  <>
                    <span style={styles.detailIcon}>📍</span>
                    <span style={styles.detailText}>
                      {user.event?.event_location || "Location TBD"}
                    </span>
                  </>
                ) : (
                  <>
                    <span style={styles.detailIcon}>🎥</span>
                    <span style={styles.detailText}>
                      {user.event?.event_link || "Meeting Link Available"}
                    </span>
                  </>
                )}
              </div>

              {/* Date and Time */}
              <div style={styles.detailRow}>
                <span style={styles.detailIcon}>📅</span>
                <span style={styles.detailText}>
                  Event: {formatDate(singleEvent?.start_time)}
                </span>
              </div>

              {/* Duration */}
              <div style={styles.detailRow}>
                <span style={styles.detailIcon}>⏱️</span>
                <span style={styles.detailText}>
                  Duration: {formatDuration(singleEvent?.duration_in_minutes)}
                </span>
              </div>

              {/* Ticket ID */}
              <div style={styles.detailRow}>
                <span style={styles.detailIcon}>🎫</span>
                <span style={styles.detailText}>Ticket ID: {user.ticket_id}</span>
              </div>

              {/* Company & Designation (if available) */}
              {user.attendee?.company && (
                <div style={styles.detailRow}>
                  <span style={styles.detailIcon}>🏢</span>
                  <span style={styles.detailText}>
                    {user.attendee.company}
                    {user.attendee?.designation && ` • ${user.attendee.designation}`}
                  </span>
                </div>
              )}

              {/* Rejection Reason (if rejected) */}
              {user.action === "REJECTED" && user.rejection_reason && (
                <div style={{...styles.detailRow, marginTop: "0.5rem", padding: "0.5rem", background: "#FFF0F0", borderRadius: "8px" }}>
                  <span style={styles.detailIcon}>⚠️</span>
                  <span style={{...styles.detailText, color: "#E03B3B"}}>
                    <strong>Reason:</strong> {user.rejection_reason}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Close Button
        <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem", marginBottom: "0.5rem" }}>
          <button onClick={onClose} style={styles.closeModalBtn}>
            Close
          </button>
        </div> */}
      </div>
    </div>
  );
};

// ── QR Camera Modal ───────────────────────────────────────────────────────────
const QRCameraModal = ({ onClose, onScanSuccess, eventId }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [error, setError] = useState(null);
  const [stream, setStream] = useState(null);
  const [checking, setChecking] = useState(true);
  const [scanning, setScanning] = useState(true);
  const [scanResult, setScanResult] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [scanMessage, setScanMessage] = useState(null);
  const [showVerification, setShowVerification] = useState(false);
  const [ticketData, setTicketData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();
  const attendeeAcessPass = useSelector((state) => state.community.attendeeAcessPass);

  // Animation frame reference
  const animationFrameRef = useRef(null);

  useEffect(() => {
    let activeStream = null;

    const startCamera = async () => {
      // 1. Check if the mediaDevices API exists at all
      if (!navigator?.mediaDevices?.getUserMedia) {
        setError({ icon: "no_device", message: "No camera found on this device." });
        setChecking(false);
        return;
      }

      // 2. Enumerate devices to see if any video input exists
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasCamera = devices.some((d) => d.kind === "videoinput");
        if (!hasCamera) {
          setError({ icon: "no_device", message: "No camera found on this device." });
          setChecking(false);
          return;
        }
      } catch (_) {
        // enumerateDevices failed — proceed and let getUserMedia handle it
      }

      // 3. Request camera access
      try {
        const s = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { ideal: "environment" } },
        });
        activeStream = s;
        setStream(s);
        if (videoRef.current) {
          videoRef.current.srcObject = s;
          videoRef.current.play();
        }
      } catch (err) {
        if (err.name === "NotFoundError" || err.name === "DevicesNotFoundError") {
          setError({ icon: "no_device", message: "No camera found on this device." });
        } else if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
          setError({ icon: "permission", message: "Camera permission denied. Please allow camera access and try again." });
        } else if (err.name === "NotReadableError" || err.name === "TrackStartError") {
          setError({ icon: "in_use", message: "Camera is already in use by another application." });
        } else {
          setError({ icon: "generic", message: "Unable to access camera. Please try again." });
        }
      } finally {
        setChecking(false);
      }
    };

    startCamera();

    return () => {
      if (activeStream) activeStream.getTracks().forEach((t) => t.stop());
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);

  // Start scanning when camera is ready
  useEffect(() => {
    if (!stream || !scanning || isProcessing || scanResult) return;

    const scanQRCode = () => {
      if (!videoRef.current || !canvasRef.current) return;

      const video = videoRef.current;
      const canvas = canvasRef.current;

      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, canvas.width, canvas.height, {
          inversionAttempts: "dontInvert",
        });

        if (code) {
          // Found a QR code
          setScanResult(code.data);
          setScanning(false);

          // Process the QR code data
          handleQRCodeData(code.data);
        }
      }

      if (scanning && !scanResult && !isProcessing) {
        animationFrameRef.current = requestAnimationFrame(scanQRCode);
      }
    };

    animationFrameRef.current = requestAnimationFrame(scanQRCode);

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [stream, scanning, isProcessing, scanResult]);

  const extractTicketId = (qrData) => {
    // If the QR data contains a pipe symbol, take only the part before it
    if (qrData && qrData.includes('|')) {
      return qrData.split('|')[0];
    }
    return qrData;
  };

  const handleQRCodeData = async (qrData) => {
    setIsProcessing(true);

    try {
      // Extract ticket ID from QR data - handle pipe separated format
      let ticketId = extractTicketId(qrData);

      console.log("Original QR Data:", qrData);
      console.log("Extracted Ticket ID:", ticketId);

      // Call GET API to fetch attendee access pass
      await dispatch(getAttendeeAccessPass(ticketId));

      setScanMessage({
        type: "success",
        text: "Ticket found! Loading details..."
      });

    } catch (error) {
      console.error("Error processing QR code:", error);
      setScanMessage({
        type: "error",
        text: "Failed to process ticket. Please try again."
      });
      setIsProcessing(false);
    }
  };

  // Handle attendeeAccessPass changes
  useEffect(() => {
    if (attendeeAcessPass && isProcessing) {
      const attendanceStatus = attendeeAcessPass.attendance_status;

      if (attendanceStatus === "PENDING") {
        // Store ticket data and show verification modal
        setTicketData(attendeeAcessPass);
        setShowVerification(true);
        setIsProcessing(false);
      } else {
        // Ticket already processed
        setScanMessage({
          type: "info",
          text: `Ticket already ${attendanceStatus.toLowerCase()}`,
          details: attendeeAcessPass
        });
        setIsProcessing(false);

        // Auto close after 3 seconds on info
        setTimeout(() => {
          handleClose();
        }, 3000);
      }
    }
  }, [attendeeAcessPass]);

  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  };

  const handleVerify = () => {
    setIsSubmitting(true);

    const payload = {
      action: "APPROVED",
      rejection_reason: ""
    };

    dispatch(patchAttendeeAccessPass({
      ticketId: ticketData.ticket_id,
      payload: payload
    })).then(() => {
      // After successful patch, fetch the updated data
      dispatch(getAttendeeAccessPass(ticketData.ticket_id));

      setScanMessage({
        type: "success",
        text: `Ticket approved for ${ticketData.attendee?.name || "Attendee"}`,
        details: ticketData
      });
      setShowVerification(false);

      // Call the onScanSuccess callback
      if (onScanSuccess) {
        onScanSuccess(ticketData.ticket_id);
      }

      // Auto close after 3 seconds on success
      setTimeout(() => {
        handleClose();
      }, 3000);
    }).catch((error) => {
      setScanMessage({
        type: "error",
        text: "Failed to approve ticket. Please try again."
      });
      setShowVerification(false);
    }).finally(() => {
      setIsSubmitting(false);
    });
  };

  const handleReject = () => {
    setIsSubmitting(true);

    const payload = {
      action: "REJECTED",
      rejection_reason: "Registration Details did not match ID Proof"
    };

    dispatch(patchAttendeeAccessPass({
      ticketId: ticketData.ticket_id,
      payload: payload
    })).then(() => {
      // After successful patch, fetch the updated data
      dispatch(getAttendeeAccessPass(ticketData.ticket_id));

      setScanMessage({
        type: "info",
        text: `Ticket rejected for ${ticketData.attendee?.name || "Attendee"}`,
        details: {
          ...ticketData,
          attendance_status: "REJECTED"
        }
      });
      setShowVerification(false);

      // Call the onScanSuccess callback
      if (onScanSuccess) {
        onScanSuccess(ticketData.ticket_id);
      }

      // Auto close after 3 seconds
      setTimeout(() => {
        handleClose();
      }, 3000);
    }).catch((error) => {
      setScanMessage({
        type: "error",
        text: "Failed to reject ticket. Please try again."
      });
      setShowVerification(false);
    }).finally(() => {
      setIsSubmitting(false);
    });
  };

  const handleClose = () => {
    if (stream) stream.getTracks().forEach((t) => t.stop());
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }
    onClose();
  };

  const handleRetry = () => {
    setScanResult(null);
    setScanMessage(null);
    setIsProcessing(false);
    setShowVerification(false);
    setTicketData(null);
    setScanning(true);
  };

  // Add these helper functions
  const formatTime = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDuration = (minutes) => {
    if (!minutes) return "N/A";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours === 0) return `${mins} mins`;
    if (mins === 0) return `${hours} hr${hours !== 1 ? "s" : ""}`;
    return `${hours} hr${hours !== 1 ? "s" : ""} ${mins} min${mins !== 1 ? "s" : ""}`;
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalBox}>
        {/* Header */}
        <div style={styles.modalHeader}>
          <span style={styles.modalTitle}>
            {showVerification ? "Verify Ticket" : "Scan QR Code"}
          </span>
          <button style={styles.closeBtn} onClick={handleClose}>
            <IoClose size={22} />
          </button>
        </div>

        {/* Camera / Checking / Error / Result / Verification */}
        {checking ? (
          <div style={styles.cameraError}>
            <div style={{ width: 40, height: 40, border: "3px solid #E4EAFB", borderTopColor: "#0044C6", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
            <p style={{ color: "#9AA5B8", marginTop: "1rem", fontSize: "0.88rem" }}>Starting camera…</p>
          </div>
        ) : error ? (
          <div style={styles.cameraError}>
            <MdOutlineQrCodeScanner size={52} color="#BCC5D4" />
            <p style={{ color: "#5A6874", marginTop: "1rem", textAlign: "center", fontSize: "0.9rem", fontWeight: 500, lineHeight: 1.5, padding: "0 1rem" }}>
              {error.message}
            </p>
            <button
              onClick={handleClose}
              style={{ marginTop: "1.2rem", background: "#0044C6", color: "#fff", border: "none", borderRadius: 40, padding: "0.6rem 1.8rem", fontSize: "0.88rem", fontWeight: 600, cursor: "pointer" }}
            >
              Close
            </button>
          </div>
        ) : showVerification && ticketData ? (
          <div style={styles.verificationContainer}>
            {/* Ticket Card - Display Only (Non-clickable) */}
            <div style={styles.ticketCardWrapper}>
              <div style={styles.ticketCard}>
                {/* Header with Gradient */}
                <div style={styles.ticketHeader}>
                  <div>
                    <span style={styles.eventTicketLabel}>EVENT TICKET</span>
                    <span style={styles.eventType}>
                      {ticketData.event?.access_level || "Public"} Event
                    </span>
                  </div>

                  {/* Group Badge or Dots */}
                  {ticketData.groupDetails?.member_count > 1 ? (
                    <div style={styles.groupBadge}>
                      Group of {ticketData.groupDetails?.member_count}
                    </div>
                  ) : (
                    <div style={styles.dotsContainer}>
                      <span style={styles.dot}></span>
                      <span style={styles.dot}></span>
                      <span style={styles.dot}></span>
                    </div>
                  )}
                </div>

                {/* Banner Image */}
                <div style={styles.bannerImage}>
                  <img
                    src={ticketData.event?.feature_image || DEFAULT_IMAGE}
                    alt="Event"
                    style={styles.bannerImg}
                    onError={(e) => {
                      e.target.src = DEFAULT_IMAGE;
                    }}
                  />
                  <div style={styles.bannerOverlay} />
                </div>

                {/* Centered Avatar overlapping banner */}
                <div style={styles.avatarContainer}>
                  <img
                    src={ticketData.attendee?.profile_url || DEFAULT_AVATAR}
                    alt={ticketData.attendee?.name}
                    style={styles.avatar}
                    onError={(e) => {
                      e.target.src = DEFAULT_AVATAR;
                    }}
                  />
                </div>

                {/* Attendee Info */}
                <div style={styles.attendeeInfo}>
                  <h4 style={styles.attendeeName}>{ticketData.attendee?.name || "N/A"}</h4>
                  <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>📧</span>
                    <span style={styles.contactText}>{ticketData.attendee?.email || "N/A"}</span>
                  </div>
                  <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>📞</span>
                    <span style={styles.contactText}>{ticketData.attendee?.phone || "N/A"}</span>
                  </div>
                </div>

                {/* Event Title & Status Chip */}
                <div style={styles.eventTitleRow}>
                  <h3 style={styles.eventTitle}>{ticketData.event?.title || "Event Name"}</h3>
                  <span style={{
                    ...styles.statusChip,
                    background: ticketData.attendance_status === "PENDING" ? "#3B5998" :
                      ticketData.attendance_status === "APPROVED" ? "#1A9E5A" : "#E03B3B",
                  }}>
                    {ticketData.attendance_status}
                  </span>
                </div>

                {/* Event Info Details */}
                <div style={styles.eventDetails}>
                  {/* Location/Meeting Link */}
                  <div style={styles.detailRow}>
                    {ticketData.event?.mode === "Offline" ? (
                      <>
                        <span style={styles.detailIcon}>📍</span>
                        <span style={styles.detailText}>
                          {ticketData.event?.event_location || "Location TBD"}
                        </span>
                      </>
                    ) : (
                      <>
                        <span style={styles.detailIcon}>🎥</span>
                        <span style={styles.detailText}>
                          {ticketData.event?.event_link || "Meeting Link Available"}
                        </span>
                      </>
                    )}
                  </div>

                  {/* Date and Time */}
                  <div style={styles.detailRow}>
                    <span style={styles.detailIcon}>📅</span>
                    <span style={styles.detailText}>
                      {formatDate(ticketData.event?.start_time)} · {formatTime(ticketData.event?.start_time)}
                    </span>
                  </div>

                  {/* Duration */}
                  <div style={styles.detailRow}>
                    <span style={styles.detailIcon}>⏱️</span>
                    <span style={styles.detailText}>
                      Duration: {formatDuration(ticketData.event?.duration_in_minutes)}
                    </span>
                  </div>

                  {/* Ticket ID */}
                  <div style={styles.detailRow}>
                    <span style={styles.detailIcon}>🎫</span>
                    <span style={styles.detailText}>Ticket ID: {ticketData.ticket_id}</span>
                  </div>

                  {/* Company & Designation (if available) */}
                  {ticketData.attendee?.company && (
                    <div style={styles.detailRow}>
                      <span style={styles.detailIcon}>🏢</span>
                      <span style={styles.detailText}>
                        {ticketData.attendee.company}
                        {ticketData.attendee?.designation && ` • ${ticketData.attendee.designation}`}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div style={styles.actionButtons}>
              <button
                onClick={handleReject}
                disabled={isSubmitting}
                style={{
                  ...styles.rejectBtn,
                  opacity: isSubmitting ? 0.6 : 1,
                  cursor: isSubmitting ? "not-allowed" : "pointer"
                }}
              >
                {isSubmitting ? "Processing..." : "Reject"}
              </button>
              <button
                onClick={handleVerify}
                disabled={isSubmitting}
                style={{
                  ...styles.verifyBtn,
                  opacity: isSubmitting ? 0.6 : 1,
                  cursor: isSubmitting ? "not-allowed" : "pointer"
                }}
              >
                {isSubmitting ? "Processing..." : "Verify"}
              </button>
            </div>
          </div>
        ) : scanMessage ? (
          <div style={styles.resultContainer}>
            {scanMessage.type === "success" ? (
              <HiOutlineCheckCircle size={64} color="#1A9E5A" />
            ) : scanMessage.type === "error" ? (
              <HiOutlineXCircle size={64} color="#E03B3B" />
            ) : (
              <MdOutlineQrCodeScanner size={64} color="#0044C6" />
            )}

            <p style={{
              color: scanMessage.type === "success" ? "#1A9E5A" : scanMessage.type === "error" ? "#E03B3B" : "#0044C6",
              marginTop: "1rem",
              fontSize: "1rem",
              fontWeight: 600,
              textAlign: "center"
            }}>
              {scanMessage.text}
            </p>

            {scanMessage.details && (
              <div style={styles.ticketDetails}>
                <p style={styles.detailText}>
                  <strong>Name:</strong> {scanMessage.details.attendee?.name || "N/A"}
                </p>
                <p style={styles.detailText}>
                  <strong>Email:</strong> {scanMessage.details.attendee?.email || "N/A"}
                </p>
                <p style={styles.detailText}>
                  <strong>Status:</strong> {scanMessage.details.attendance_status}
                </p>
                <p style={styles.detailText}>
                  <strong>Ticket ID:</strong> {scanMessage.details.ticket_id}
                </p>
              </div>
            )}

            {scanMessage.type === "error" && (
              <button
                onClick={handleRetry}
                style={styles.retryBtn}
              >
                Try Again
              </button>
            )}

            {scanMessage.type === "success" && (
              <p style={styles.autoCloseText}>Closing automatically...</p>
            )}
          </div>
        ) : (
          <div style={styles.cameraWrapper}>
            <video ref={videoRef} autoPlay playsInline muted style={styles.video} />
            <canvas ref={canvasRef} style={{ display: 'none' }} />
            {/* scanning frame */}
            <div style={styles.scanFrame}>
              <div style={{ ...styles.corner, top: 0, left: 0, borderTop: "3px solid #0044C6", borderLeft: "3px solid #0044C6" }} />
              <div style={{ ...styles.corner, top: 0, right: 0, borderTop: "3px solid #0044C6", borderRight: "3px solid #0044C6" }} />
              <div style={{ ...styles.corner, bottom: 0, left: 0, borderBottom: "3px solid #0044C6", borderLeft: "3px solid #0044C6" }} />
              <div style={{ ...styles.corner, bottom: 0, right: 0, borderBottom: "3px solid #0044C6", borderRight: "3px solid #0044C6" }} />
              <div style={styles.scanLine} />
            </div>
          </div>
        )}

        {!error && !checking && !scanMessage && !showVerification && (
          <p style={styles.scanHint}>Point the camera at a QR code to scan</p>
        )}
      </div>

      <style>{`
        @keyframes scanMove {
          0%   { top: 0%; }
          50%  { top: calc(100% - 2px); }
          100% { top: 0%; }
        }
        @keyframes spin  { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

// ── Main component ────────────────────────────────────────────────────────────
const VolunteerDashBoard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const singleEvent = useSelector((state) => state?.community?.singleEvent);
  const accessLogs = useSelector((state) => state?.community?.geteventaccessbyId);
  const attendeeAcessPass = useSelector(
    (state) => state.community.attendeeAcessPass
  );
console.log("singleEvent++++", singleEvent)
  const [showCamera, setShowCamera] = useState(false);
  const [isLoadingLogs, setIsLoadingLogs] = useState(false);
  const [scanSuccessMessage, setScanSuccessMessage] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null); // State for selected user
  const [showUserModal, setShowUserModal] = useState(false); // State for user modal visibility

  const primaryBlue = "#0044C6";

  const formatDate = (iso) => {
    if (!iso) return "";
    return new Date(iso).toLocaleDateString("en-US", {
      day: "numeric", month: "long", year: "numeric",
    });
  };

  const formatLogTime = (iso) => {
    if (!iso) return "";
    return new Date(iso).toLocaleString("en-US", {
      day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
    });
  };

  // Fetch access logs on mount
  useEffect(() => {
    if (!singleEvent?.id) return;
    setIsLoadingLogs(true);
    dispatch(getEventAccessLogs({ eventId: singleEvent?.id })).finally(() =>
      setIsLoadingLogs(false)
    );
  }, [singleEvent?.id, dispatch]);

  // Clear scan success message after 3 seconds
  useEffect(() => {
    if (scanSuccessMessage) {
      const timer = setTimeout(() => {
        setScanSuccessMessage(null);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [scanSuccessMessage]);

  const handleGoBack = () => navigate(-1);

  const handleViewMyLogs = () => {
    dispatch(getEventAccessLogs({ eventId: singleEvent?.id }));
    navigate("/access-logs");
  };

  const handleScanSuccess = (ticketId) => {
    setScanSuccessMessage(`Ticket ${ticketId} successfully approved!`);
    // Refresh the access logs after successful scan
    dispatch(getEventAccessLogs({ eventId: singleEvent?.id }));
  };

  // Handle clicking on a log row
  const handleLogClick = (log) => {
    setSelectedUser(log);
    setShowUserModal(true);
  };

  // Close user modal
  const handleCloseUserModal = () => {
    setShowUserModal(false);
    setSelectedUser(null);
  };

  const eventLocation = singleEvent?.event_location || "";
  const eventDate = formatDate(singleEvent?.start_time);

  const recentLogs = accessLogs ? accessLogs.slice(0, 10) : [];

  return (
    <div style={{ width: "95%", minHeight: "100vh", background: "#F4F6FB", fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
      <style>{`
        @keyframes spin  { to { transform: rotate(360deg); } }
        @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.45; } }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0);    }
        }
      `}</style>

      {/* ── Cover Photo ──────────────────────────────────────────────────── */}
      {singleEvent?.feature_image && (
        <div style={{
          width: "100%", height: 220,
          backgroundImage: `url(${singleEvent.feature_image})`,
          backgroundSize: "cover", backgroundPosition: "center",
          position: "relative",
        }}>
          <div style={{
            position: "absolute", inset: 0,
            background: "linear-gradient(180deg, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.65) 100%)",
          }} />

          {/* Back button */}
          <button onClick={handleGoBack} style={styles.backBtn}>
            <span style={{ fontSize: "1.1rem" }}>←</span> Back
          </button>

          {/* Category badge */}
          {singleEvent?.event_category && (
            <div style={styles.categoryBadge}>{singleEvent.event_category}</div>
          )}

          {/* Event title overlay */}
          <div style={styles.coverTitleWrapper}>
            <h1 style={styles.coverTitle}>{singleEvent?.title || "Event Title"}</h1>
            <div style={styles.metaRow}>
              {eventLocation && (
                <span style={styles.metaItem}><SlLocationPin /> {eventLocation}</span>
              )}
              {eventDate && (
                <span style={styles.metaItem}><MdOutlineCalendarMonth /> {eventDate}</span>
              )}
              {singleEvent?.mode && (
                <span style={styles.metaItem}><IoCloudOfflineOutline /> {singleEvent.mode}</span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── Body ─────────────────────────────────────────────────────────── */}
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "2rem", fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>

        {/* Scan Success Message */}
        {scanSuccessMessage && (
          <div style={styles.successMessage}>
            <HiOutlineCheckCircle size={20} color="#1A9E5A" />
            <span>{scanSuccessMessage}</span>
          </div>
        )}

        {/* If no feature image, show header normally */}
        {!singleEvent?.feature_image && (
          <div style={{ marginBottom: "1.5rem" }}>
            <h1 style={{ fontSize: "1.6rem", fontWeight: 700, color: "#0B1C33", margin: "0 0 0.4rem" }}>
              {singleEvent?.title || "Event Title"}
            </h1>
            <div style={styles.metaRow}>
              {eventLocation && <span style={{ ...styles.metaItem, color: "#5A6874" }}><SlLocationPin /> {eventLocation}</span>}
              {eventDate && <span style={{ ...styles.metaItem, color: "#5A6874" }}><MdOutlineCalendarMonth /> {eventDate}</span>}
              {singleEvent?.mode && <span style={{ ...styles.metaItem, color: "#5A6874" }}><IoCloudOfflineOutline /> {singleEvent.mode}</span>}
            </div>
          </div>
        )}

        {/* ── Action Buttons: Scan QR + My Logs ─────────────────────────── */}
        <div style={styles.actionGrid}>
          {/* Scan QR */}
          <button onClick={() => setShowCamera(true)} style={styles.actionBtn}>
            <MdOutlineQrCodeScanner size={32} color={primaryBlue} />
            <span style={styles.actionLabel}>Scan QR</span>
          </button>

          {/* My Logs */}
          <button onClick={handleViewMyLogs} style={styles.actionBtn}>
            <PiClockClockwise size={32} color={primaryBlue} />
            <span style={styles.actionLabel}>My Logs</span>
          </button>
        </div>

        {/* ── Recent Activity ───────────────────────────────────────────── */}
        <div style={{ marginTop: "2rem", animation: "fadeUp 0.4s ease both" }}>
          <h3 style={styles.sectionTitle}>Recent Activity</h3>

          {isLoadingLogs ? (
            <div style={styles.logsContainer}>
              {Array(4).fill(0).map((_, i) => (
                <div key={i} style={{ ...styles.logSkeleton, animationDelay: `${i * 0.1}s` }} />
              ))}
            </div>
          ) : recentLogs.length === 0 ? (
            <div style={styles.emptyState}>
              <PiClockClockwise size={40} color="#BCC5D4" />
              <p style={{ color: "#9AA5B8", marginTop: "0.75rem", fontSize: "0.92rem" }}>
                No recent activity yet
              </p>
            </div>
          ) : (
            <div style={styles.logsContainer}>
              {recentLogs.map((log, i) => {
                const attendeeName = log.attendee?.name?.trim() || "Unknown User";
                const attendeeEmail = log.attendee?.email || "";
                const avatarUrl = log.attendee?.profile_url || "";
                const performedBy = log.performed_by?.name || log.created_by?.split("<")[0]?.trim() || "";
                const action = log.action || log.attendance_status || "";
                const isApproved = action === "APPROVED";
                const isRejected = action === "REJECTED";

                return (
                  <div 
                    key={log.id ?? i} 
                    style={{ ...styles.logRow, animationDelay: `${i * 0.06}s`, cursor: "pointer" }}
                    onClick={() => handleLogClick(log)} // Add click handler
                  >

                    {/* Avatar */}
                    <div style={styles.logAvatar}>
                      {avatarUrl ? (
                        <img
                          src={avatarUrl}
                          alt={attendeeName}
                          style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                          onError={(e) => { e.currentTarget.style.display = "none"; }}
                        />
                      ) : (
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="#9AA5B8">
                          <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
                        </svg>
                      )}
                    </div>

                    {/* Name + Email */}
                    <div style={{ flex: 1.2, minWidth: 0 }}>
                      <div style={styles.logName}>{attendeeName}</div>
                      <div style={styles.logEmail}>{attendeeEmail}</div>
                    </div>

                    {/* Performed By */}
                    <div style={styles.logPerformedBy}>
                      <div style={styles.logPerformedByLabel}>Performed By :</div>
                      <div style={styles.logPerformedByName}>{performedBy}</div>
                    </div>

                    {/* Date + Status */}
                    <div style={styles.logRight}>
                      <div style={styles.logTime}>{formatLogTime(log.created_at)}</div>
                      <div style={{
                        ...styles.statusBadge,
                        background: isApproved ? "#E8F9F0" : isRejected ? "#FFF0F0" : "#F4F6FB",
                        color: isApproved ? "#1A9E5A" : isRejected ? "#E03B3B" : "#6F7D95",
                        border: `1px solid ${isApproved ? "#B6EDD4" : isRejected ? "#F5C6C6" : "#E4EAFB"}`,
                      }}>
                        {action}
                      </div>
                    </div>

                  </div>
                );
              })}
            </div>
          )}
        </div>
        {/* end recent activity */}

      </div>
      {/* end body */}

      {/* ── QR Camera Modal ─────────────────────────────────────────────── */}
      {showCamera && (
        <QRCameraModal
          onClose={() => setShowCamera(false)}
          onScanSuccess={handleScanSuccess}
          eventId={singleEvent?.id}
        />
      )}

      {/* ── User Details Modal ──────────────────────────────────────────── */}
      {showUserModal && selectedUser && (
        <UserDetailsModal
          user={selectedUser}
          onClose={handleCloseUserModal}
          singleEvent={singleEvent}
        />
      )}
    </div>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────
const styles = {
  // Cover
  backBtn: {
    position: "absolute", top: 16, left: 16,
    background: "rgba(255,255,255,0.88)", border: "none",
    borderRadius: 40, padding: "0.5rem 1.1rem",
    fontSize: "0.88rem", fontWeight: 600, cursor: "pointer",
    display: "flex", alignItems: "center", gap: "0.4rem",
    color: "#0B1C33", backdropFilter: "blur(6px)", zIndex: 10,
    boxShadow: "0 2px 10px rgba(0,0,0,0.18)",
  },
  categoryBadge: {
    position: "absolute", top: 16, right: 16,
    background: "#0044C6", color: "#fff",
    borderRadius: 40, padding: "0.45rem 1.2rem",
    fontSize: "0.8rem", fontWeight: 600,
    textTransform: "uppercase", letterSpacing: "0.5px", zIndex: 10,
  },
  coverTitleWrapper: {
    position: "absolute", bottom: 18, left: 18, right: 18, zIndex: 10,
  },
  coverTitle: {
    fontSize: "1.45rem", fontWeight: 700, color: "#fff",
    margin: "0 0 0.4rem", lineHeight: 1.25,
    textShadow: "0 1px 4px rgba(0,0,0,0.4)",
  },
  metaRow: {
    display: "flex", gap: "1.2rem", flexWrap: "wrap",
    fontSize: "0.82rem",
  },
  metaItem: {
    display: "flex", alignItems: "center", gap: "0.35rem", color: "rgba(255,255,255,0.9)",
  },

  // Action buttons
  actionGrid: {
    display: "grid", gridTemplateColumns: "1fr 1fr",
    gap: "1rem", marginTop: "1.2rem",
  },
  actionBtn: {
    background: "#fff", border: "1.5px solid #E4EAFB",
    borderRadius: 20, padding: "1.5rem 1rem",
    display: "flex", flexDirection: "column",
    alignItems: "center", gap: "0.65rem",
    cursor: "pointer",
    boxShadow: "0 4px 14px -4px rgba(0,68,198,0.10)",
    transition: "all 0.15s",
  },
  actionLabel: {
    fontSize: "0.95rem", fontWeight: 600, color: "#0B1C33",
  },

  // Section title
  sectionTitle: {
    fontSize: "1.05rem", fontWeight: 700, color: "#0B1C33",
    margin: "0 0 1rem", letterSpacing: "-0.01em",
  },

  // Logs
  logsContainer: {
    display: "flex", flexDirection: "column",
    background: "#fff", borderRadius: 16,
    border: "1px solid #EEF1F8",
    boxShadow: "0 2px 8px -4px rgba(0,68,198,0.08)",
    overflow: "hidden",
    padding: "0 0.75rem",
  },
  logRow: {
    background: "#fff", borderRadius: 0,
    padding: "1rem 0.5rem",
    display: "flex", alignItems: "center", gap: "0.85rem",
    borderBottom: "1px solid #EEF1F8",
    animation: "fadeUp 0.35s ease both",
  },
  logAvatar: {
    width: 44, height: 44, borderRadius: "50%",
    background: "#E9EDF4",
    display: "flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0, overflow: "hidden",
  },
  logName: {
    fontSize: "0.92rem", fontWeight: 700, color: "#0B1C33",
    whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
  },
  logEmail: {
    fontSize: "0.78rem", color: "#7A8FA8", marginTop: "0.15rem",
  },
  logPerformedBy: {
    flex: 1, minWidth: 100,
  },
  logPerformedByLabel: {
    fontSize: "0.78rem", color: "#7A8FA8",
  },
  logPerformedByName: {
    fontSize: "0.88rem", fontWeight: 600, color: "#0B1C33", marginTop: "0.15rem",
  },
  logRight: {
    display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.4rem", flexShrink: 0,
  },
  logTime: {
    fontSize: "0.78rem", color: "#7A8FA8", whiteSpace: "nowrap",
  },
  statusBadge: {
    fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.05em",
    borderRadius: 40, padding: "0.25rem 0.85rem",
    textTransform: "uppercase", whiteSpace: "nowrap",
  },
  logSkeleton: {
    height: 60, borderRadius: 16,
    background: "#E9EDF4",
    animation: "pulse 1.5s ease-in-out infinite",
  },
  emptyState: {
    background: "#fff", borderRadius: 20, padding: "2.5rem 1rem",
    display: "flex", flexDirection: "column", alignItems: "center",
    border: "1px dashed #D8DFF0",
  },

  // Camera modal
  modalOverlay: {
    position: "fixed", inset: 0, zIndex: 1000,
    background: "rgba(10,20,45,0.85)", backdropFilter: "blur(8px)",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  modalBox: {
    background: "#F4F6FB",
    width: "95%",
    maxWidth: 700,
    borderRadius: "28px",
    padding: "1rem",
    boxShadow: "0 20px 60px rgba(0,68,198,0.3)",
    maxHeight: "90vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
    padding: "0 0.5rem",
    flexShrink: 0,
  },
  modalTitle: {
    fontSize: "1.2rem",
    fontWeight: 700,
    color: "#0B1C33",
  },
  headerButtons: {
    display: "flex",
    gap: "0.75rem",
    marginLeft: "auto",
    marginRight: "1rem",
  },
  headerVerifyBtn: {
    background: "linear-gradient(90deg, #253A7D 0%, #3B5998 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "15px",
    fontWeight: 600,
    fontSize: "0.9rem",
    padding: "0.5rem 1.2rem",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(44,62,80,0.15)",
    transition: "all 0.2s",
    letterSpacing: "0.3px",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(44,62,80,0.2)",
    },
  },
  headerRejectBtn: {
    background: "#fff",
    color: "#E03B3B",
    border: "1.5px solid #FFE5E5",
    borderRadius: "40px",
    fontWeight: 600,
    fontSize: "0.9rem",
    padding: "0.5rem 1.2rem",
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      background: "#FFF0F0",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(224,59,59,0.1)",
    },
  },
  closeBtn: {
    background: "#fff",
    border: "none",
    borderRadius: "50%",
    width: 36,
    height: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#5A6874",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    flexShrink: 0,
    "&:hover": {
      background: "#f0f0f0",
    },
  },
  closeModalBtn: {
    background: "#0044C6",
    color: "#fff",
    border: "none",
    borderRadius: "40px",
    fontWeight: 600,
    fontSize: "1rem",
    padding: "0.75rem 2rem",
    cursor: "pointer",
    transition: "all 0.2s",
    boxShadow: "0 4px 12px rgba(0,68,198,0.3)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(0,68,198,0.4)",
    },
  },
  cameraWrapper: {
    position: "relative", width: "100%",
    aspectRatio: "1 / 1", borderRadius: 20, overflow: "hidden",
    background: "#000",
  },
  video: {
    width: "100%", height: "100%",
    objectFit: "cover", display: "block",
  },
  scanFrame: {
    position: "absolute", inset: "15%",
    border: "none",
  },
  corner: {
    position: "absolute", width: 24, height: 24, borderRadius: 3,
  },
  scanLine: {
    position: "absolute", left: 0, right: 0,
    height: 2,
    background: "linear-gradient(90deg, transparent, #0044C6, transparent)",
    animation: "scanMove 2s linear infinite",
    boxShadow: "0 0 8px rgba(0,68,198,0.6)",
  },
  cameraError: {
    width: "100%", aspectRatio: "1 / 1",
    background: "#F4F6FB", borderRadius: 20,
    display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center",
  },
  scanHint: {
    textAlign: "center", color: "#9AA5B8",
    fontSize: "0.82rem", marginTop: "1rem",
  },
  resultContainer: {
    width: "100%", aspectRatio: "1 / 1",
    background: "#F4F6FB", borderRadius: 20,
    display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center",
    padding: "1.5rem",
  },
  ticketDetails: {
    marginTop: "1rem",
    padding: "1rem",
    background: "#fff",
    borderRadius: 12,
    width: "100%",
  },
  detailText: {
    fontSize: "0.85rem",
    color: "#0B1C33",
    margin: "0.3rem 0",
    wordBreak: "break-word",
  },
  retryBtn: {
    marginTop: "1.2rem",
    background: "#0044C6",
    color: "#fff",
    border: "none",
    borderRadius: 40,
    padding: "0.6rem 1.8rem",
    fontSize: "0.88rem",
    fontWeight: 600,
    cursor: "pointer",
  },
  autoCloseText: {
    marginTop: "1rem",
    fontSize: "0.8rem",
    color: "#9AA5B8",
    fontStyle: "italic",
  },
  successMessage: {
    background: "#E8F9F0",
    border: "1px solid #B6EDD4",
    borderRadius: 12,
    padding: "1rem",
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    color: "#1A9E5A",
    fontSize: "0.95rem",
    fontWeight: 500,
  },
  // Add these new styles to your existing styles object
  verificationContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    flex: 1,
    padding: "0.5rem",
  },
  verificationHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
    padding: "0 0.25rem",
    flexShrink: 0,
  },
  verificationTitle: {
    fontSize: "1.2rem",
    fontWeight: 700,
    color: "#0B1C33",
  },
  ticketCardWrapper: {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  overflowY: "scroll",
  overflowX: "hidden",
  flex: 1,
  padding: "0.5rem",

  /* Hide scrollbar for Chrome, Safari */
  "&::-webkit-scrollbar": {
    display: "none",
  },

  /* Hide scrollbar for Firefox */
  scrollbarWidth: "none",

  /* Hide scrollbar for IE/Edge */
  msOverflowStyle: "none",
},
  ticketCard: {
    background: "#fff",
    borderRadius: "24px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
    overflow: "hidden",
    width: "60%",
    pointerEvents: "none", // Make card non-clickable
  },
  ticketHeader: {
    background: "linear-gradient(135deg, #253A7D 0%, #3B5998 100%)",
    color: "#fff",
    padding: "1rem 1rem 0.5rem 1rem", // Reduced padding
    borderTopLeftRadius: "24px",
    borderTopRightRadius: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  eventTicketLabel: {
    display: "block",
    fontWeight: 700,
    fontSize: "14px", // Slightly smaller
    letterSpacing: "1px",
    marginBottom: "0.1rem",
  },
  eventType: {
    display: "block",
    fontSize: "10px",
    opacity: 0.85,
  },
  groupBadge: {
    background: "rgba(255,255,255,0.2)",
    border: "1px solid rgba(255,255,255,0.5)",
    borderRadius: "15px",
    color: "#fff",
    fontSize: "11px",
    padding: "3px 10px",
  },
  dotsContainer: {
    display: "flex",
    gap: "4px",
  },
  dot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: "#fff",
    opacity: 0.7,
    "&:nth-child(1)": { opacity: 0.4 },
    "&:nth-child(2)": { opacity: 0.4 },
    "&:nth-child(3)": { opacity: 0.7 },
  },
  bannerImage: {
    width: "100%",
    height: "140px", // Reduced height
    position: "relative",
    overflow: "hidden",
  },
  bannerImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  bannerOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "linear-gradient(180deg, rgba(43,59,120,0.15) 0%, rgba(255,255,255,0) 100%)",
    zIndex: 1,
  },
  avatarContainer: {
    display: "flex",
    justifyContent: "left",
    position: "relative",
    zIndex: 2,
    marginTop: "-45px", // Adjusted for smaller banner
    marginLeft: "1rem",
  },
  avatar: {
    width: "80px", // Smaller avatar
    height: "80px",
    borderRadius: "50%",
    border: "3px solid #0044C6",
    boxShadow: "0 4px 12px rgba(44,62,80,0.2)",
    background: "#fff",
    objectFit: "cover",
  },
  attendeeInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    marginTop: "0.5rem",
    padding: "0 1rem", // Reduced padding
  },
  attendeeName: {
    fontSize: "18px", // Smaller
    fontWeight: 700,
    margin: "0 0 0.2rem 0",
    color: "#0B1C33",
  },
  contactRow: {
    display: "flex",
    alignItems: "center",
    fontSize: "13px", // Smaller
    color: "#5A6874",
    marginBottom: "0.1rem",
  },
  contactIcon: {
    fontSize: "14px", // Smaller
    marginRight: "0.5rem",
    minWidth: "18px",
  },
  contactText: {
    fontSize: "13px",
  },
  eventTitleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "1rem",
    padding: "0 1rem", // Reduced padding
  },
  eventTitle: {
    fontSize: "18px", // Smaller
    fontWeight: 700,
    margin: 0,
    flex: 1,
    color: "#0B1C33",
    lineHeight: 1.3,
  },
  statusChip: {
    fontSize: "12px", // Smaller
    fontWeight: 600,
    color: "#fff",
    padding: "3px 10px", // Smaller padding
    borderRadius: "16px",
    marginLeft: "0.75rem",
    whiteSpace: "nowrap",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  eventDetails: {
    padding: "0.75rem 1rem 1rem 1rem", // Reduced padding
  },
  detailRow: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "0.5rem", // Reduced margin
    fontSize: "13px", // Smaller
    color: "#2C3E50",
    lineHeight: 1.4,
  },
  detailIcon: {
    fontSize: "16px", // Smaller
    marginRight: "0.5rem",
    minWidth: "20px",
    color: "#3B5998",
  },
  detailText: {
    flex: 1,
    wordBreak: "break-word",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "center",
    gap: "1.5rem",
    marginTop: "1.5rem",
    marginBottom: "0.5rem",
    padding: "0 1rem",
  },
  verifyBtn: {
    background: "linear-gradient(90deg, #253A7D 0%, #3B5998 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "40px",
    fontWeight: 700,
    fontSize: "16px",
    padding: "12px 32px", // Wider button
    minWidth: "140px", // Minimum width
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(44,62,80,0.15)",
    transition: "all 0.2s",
    letterSpacing: "0.5px",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(44,62,80,0.2)",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
      transform: "none",
    },
  },
  rejectBtn: {
    background: "#fff",
    color: "#E03B3B",
    border: "2px solid #FFE5E5",
    borderRadius: "40px",
    fontWeight: 700,
    fontSize: "16px",
    padding: "12px 32px", // Wider button
    minWidth: "140px", // Minimum width
    cursor: "pointer",
    transition: "all 0.2s",
    letterSpacing: "0.5px",
    "&:hover": {
      background: "#FFF0F0",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(224,59,59,0.15)",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
      transform: "none",
    },
  },
};

export default VolunteerDashBoard;